module.exports = __webpack_public_path__ + "static/img/college3.ba2acfa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college3.jpeg
// module id = T9JJ
// module chunks = 45